import { ILoginRequest } from '../dtos/requests/login.request';
import { IToken } from '../dtos/responses/token.response';
import {Observable, of} from 'rxjs';
import { IRefreshTokenRequest } from '../dtos/requests/refresh.request';
import { IResendConfirmationEmailRequest } from '../dtos/requests/resend-confirmation-email.request';
import { IForgotPasswordRequest } from '../dtos/requests/forgot-password.request';
import { IResetPasswordRequest } from '../dtos/requests/reset-password.request';
import { Injectable } from '@angular/core';
import {IIdentityAbiClient} from "./identity-api-client.interface";
import {Logger} from "../../../../core/utilities/logging/logger";
import {testTokenData} from "../data/token.data";

@Injectable({
    providedIn: 'root'
})
export class IdentityInMemoryApiClient implements IIdentityAbiClient {
    constructor() {
    }

    login(request: ILoginRequest): Observable<IToken> {
       Logger.debug("using in memory client");
       Logger.debug(testTokenData);
       return of(testTokenData);
    }

    refresh(request: IRefreshTokenRequest): Observable<IToken> {
      return of(testTokenData);
    }

    resendConfirmationEmail(request: IResendConfirmationEmailRequest): Observable<IToken> {
      return of(testTokenData);
    }

    forgotPassword(request: IForgotPasswordRequest): Observable<IToken> {
      return of(testTokenData);
    }

    resetPassword(request: IResetPasswordRequest): Observable<IToken> {
      return of(testTokenData);
    }
}
